import { api } from '@/utils/Api';
import { useBuildingIds } from '@smartfm/container/hooks/useBuildingIds';
import { useClientId } from '@smartfm/container/hooks/useClientId';
import { useQuery } from '@tanstack/react-query';
import { useNavigationCtx } from '@/components/NavigationProvider';
import type { Option } from '@/types';

const appName = 'Container UI';

function handleDataMap(
  data: any,
  id: string | undefined,
  parentPath: string[],
  allOptions: Option[]
): { item: Option; allOptions: Option[] } | null {
  if (!data || !id) return null;
  let result = null;
  for (const item of data) {
    allOptions.push(item);
    if (item.nexusId === id) {
      item.parentPath = parentPath;
      result = item;
    } else if (item.children && item.children.length > 0) {
      const found = handleDataMap(
        item.children,
        id,
        [...parentPath, item.nexusId],
        allOptions
      );
      if (found) {
        return found;
      }
    }
  }
  return { allOptions, item: result };
}

function getID(clientId?: string, buildingIds?: string[]): string | undefined {
  if (buildingIds?.length === 1) {
    return buildingIds[0];
  }
  if (clientId) {
    return clientId;
  }
}

export const useNavigationData = () => {
  const navigationCtx = useNavigationCtx();
  const [_, buildindIds] = useBuildingIds();
  const [client] = useClientId();
  const id = getID(client, buildindIds);
  return useQuery({
    enabled: Boolean(id),
    queryFn: () =>
      api
        .post('navigation/cascadenavigation', {
          appName,
          cascader: id === 'null' ? 'true' : 'false',
          id: id || null,
        })
        .then(res => {
          const data = handleDataMap(
            res?.data.children,
            id,
            [res?.data.nexusId],
            []
          ) as {
            item: Option;
            allOptions: Option[];
          } | null;
          navigationCtx?.setState(
            prev =>
              ({
                ...prev,
                allOptions: data?.allOptions,
                selectedOption: data?.item,
              }) as any
          );
          return data?.item;
        }),
    queryKey: ['cascadenavigation', id, appName],
  });
};
